module.exports = __webpack_public_path__ + "img/hand.278f3224.svg";